var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ol',{attrs:{"id":"itemList"}},[(_vm.isListEmpty)?_c('li',{staticClass:"item"},[_vm._v("None Selected")]):_vm._e(),_vm._l((_vm.itemList),function(item){return _c('li',{key:item.id,staticClass:"item"},[_vm._v(" "+_vm._s(item[ _vm.displayedKey ])+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }